import { productHierarchyQueryParam } from './constants'

import type { ProductHierarchyTreeData } from '@app/pages/RegistryPageInner/ui/ProductHierarchyTableSidebar/types'
import type {
  CategoriesDto,
  SubcategoriesDto,
  CommodityGroupsDto,
  PurchasingGroupsDto,
  ProductHierarchyDto
} from '@app/api/routes/productHierarchy/dtos'

const getSubcategories = (parentKey: string, subcategories: SubcategoriesDto[]): ProductHierarchyTreeData[] => {
  return subcategories.map(subcategory => {
    const key = `${parentKey}_${subcategory.id}`

    return {
      key,
      id: subcategory.id,
      title: subcategory.id,
      queryParamKey: productHierarchyQueryParam.SUBCATEGORY
    }
  })
}

const getCategories = (parentKey: string, categories: CategoriesDto[]): ProductHierarchyTreeData[] => {
  return categories.map(category => {
    const key = `${parentKey}_${category.id}`

    return {
      key,
      id: category.id,
      title: category.id,
      queryParamKey: productHierarchyQueryParam.CATEGORY,
      children: getSubcategories(key, category.subcategories)
    }
  })
}

const getCommodityGroups = (parentKey: string, commodityGroups: CommodityGroupsDto[]): ProductHierarchyTreeData[] => {
  return commodityGroups.map(commodityGroup => {
    const key = `${parentKey}_${commodityGroup.id}`

    return {
      key,
      id: commodityGroup.id,
      title: commodityGroup.id,
      queryParamKey: productHierarchyQueryParam.COMMODITY_GROUP,
      children: getCategories(key, commodityGroup.categories)
    }
  })
}

const getPurchasingGroups = (
  parentKey: string,
  purchasingGroups: PurchasingGroupsDto[]
): ProductHierarchyTreeData[] => {
  return purchasingGroups.map(purchasingGroup => {
    const key = `${parentKey}_${purchasingGroup.id}`

    return {
      key,
      id: purchasingGroup.id,
      title: purchasingGroup.id,
      queryParamKey: productHierarchyQueryParam.PURCHASING_GROUP,
      children: getCommodityGroups(key, purchasingGroup.commodityGroups)
    }
  })
}

export const productHierarchyAdapter = (
  productHierarchy?: ProductHierarchyDto[]
): ProductHierarchyTreeData[] | undefined => {
  return productHierarchy?.map(trend => {
    return {
      key: trend.id,
      id: trend.id,
      title: trend.id,
      queryParamKey: productHierarchyQueryParam.TREND,
      children: getPurchasingGroups(trend.id, trend.purchasingGroups)
    }
  })
}
